export { setupOlark }

function setupOlark(userName, userEmail) {
  /* eslint-disable */
  (function(o,l,a,r,k,y){if(o.olark)return; r="script";y=l.createElement(r);r=l.getElementsByTagName(r)[0]; y.async=1;y.src="//"+a;r.parentNode.insertBefore(y,r); y=o.olark=function(){k.s.push(arguments);k.t.push(+new Date)}; y.extend=function(i,j){y("extend",i,j)}; y.identify=function(i){y("identify",k.i=i)}; y.configure=function(i,j){y("configure",i,j);k.c[i]=j}; k=y._={s:[],t:[+new Date],c:{},l:a}; })(window,document,"static.olark.com/jsclient/loader.js");
  /* eslint-enable */

  // Olark configuration
  /* global olark */
  olark.configure('system.group', '3e254301cc73a13d90e1e5cc164a2128') /* Routes to Toolkit */
  olark.identify('9997-721-10-8461')
  olark('api.chat.updateVisitorNickname', {
    snippet: userEmail
  })
  olark('api.visitor.updateEmailAddress', {
    emailAddress: userEmail
  })
  olark('api.visitor.updateFullName', {
    fullName: userName
  })
}
